import {SalToast} from "@utilities/sal-toast/sal-toast";

export const pimImageList = (elements) => {
    const toastArea = document.createElement("div")
    toastArea.classList.add("pim-image-list__toasts", "sal-toast__area")

    document.body.appendChild(toastArea);

    elements.forEach(element => {
        const toasts = new SalToast({
            timeout: undefined,
            toastArea: "pim-image-list__toasts"
        })

        const button = document.createElement("button");
        button.classList.add("sal-toast__trigger");

        const title = element.getAttribute("data-toast-title")
        const body = element.getAttribute("data-toast-body")
        const imageSrc = element.getAttribute("data-toast-image");

        if (title && imageSrc) {
            button.addEventListener("click", () => {
                const image = {
                    src: imageSrc,
                    alt: title,
                    showMobile: true
                }

                toasts.createToast(title, undefined, toasts.types.MESSAGE, undefined, body, image)
            })

            element.parentElement.appendChild(button);
        }
    })
}
